import { IAuth } from "models/auth.model";
import { useContext, useEffect } from "react";
import { useHostStore } from "host/HostStore";
import type { PropsWithChildren } from "react";
import { useLocation } from "react-router-dom";
import AppContext, { AppContextType } from "store/context/AppContext/AppContext";

const BuildLayout = (props: PropsWithChildren) => {
    const appCtx = useContext(AppContext);
    const location = useLocation();
    const { auth } = useHostStore();

    const executeOnBoardingCompleteCheck = (appCtx: AppContextType, auth: IAuth) => {
        if (auth && auth.productName) {
            return;
        }

        appCtx.setExecuteOnBoardingCompleteCheck(false);

        const regexPattern = /^\/build\/get-started\/module\/.*\/setup$/;
        const regexPattern2 = /^\/build\/get-started\/module\/.*\/$/;
        const pathname = location.pathname;
        const isMatch = regexPattern.test(pathname) || regexPattern2.test(pathname);

        if (!isMatch) {
            const onBoardingCompleteCheckTimer = setTimeout(() => {
                clearTimeout(onBoardingCompleteCheckTimer);
                appCtx.setExecuteOnBoardingCompleteCheck(true);
            }, 5000);
        }
    };

    useEffect(() => {
        executeOnBoardingCompleteCheck(appCtx, auth);
    }, [location.pathname]);

    return props.children;
};

export default BuildLayout;
